<template>
  <tbody>
    <tr
      :key="line.id"
      :class="'chunk-operation-' + line.op"
      @mouseover="isVisible = isSeparator ? false : true"
      @mouseleave="isVisible = false"
    >
      <td
        v-if="hasDiscussions"
        class="chunk-btn-holder p-0"
      >
        <button
          v-if="
            isVisible && !discussion && getActionAvailabilityFlag(ACTION_ENUM.CREATE_DISCUSSION)
          "
          class="btn btn-primary chunk-line-btn"
          type="button"
          @click.prevent="showEditor = true"
        >
          +
        </button>
      </td>
      <td
        class="chunk-num no-select text-secondary pl-3 pr-1 py-0"
        :data-before="line.removeLineNumber || '...'"
      ></td>
      <td
        class="chunk-num no-select text-secondary pl-3 pr-1 py-0"
        :data-before="line.addLineNumber || '...'"
      ></td>
      <td
        class="py-0"
        :class="line.type === 'line' ? 'chunk-line' : 'header'"
        v-html="line.type === 'line' ? line.highLightBody : line.body"
      ></td>
    </tr>
    <Transition
      name="discussion"
      tag="tr"
    >
      <tr v-if="hasDiscussions && discussion">
        <td
          colspan="4"
          class="p-0"
        >
          <div class="discussion-holder">
            <merge-request-discussion-reply
              :key="discussion.id"
              :reply="discussion"
              @deleteDiscussion="onDiscussionDelete"
            />
            <div v-if="!areRepliesHidden">
              <merge-request-discussion-reply
                v-for="reply in discussion.replies"
                :key="reply.id"
                :reply="reply"
                @deleteDiscussion="onDiscussionReplyDelete"
              />
            </div>
            <div
              v-if="discussion?.replies?.length > 0"
              class="d-flex justify-content-center pb-2"
            >
              <button
                class="btn btn-sm text-primary"
                @click="areRepliesHidden = !areRepliesHidden"
              >
                {{ hideRepliesButtonText }}
                <i
                  class="ml-2"
                  :class="hideRepliesButtonIcon"
                ></i>
              </button>
            </div>
          </div>
          <merge-request-discussion-reply-form
            :close-on-unfocus="true"
            :class="{ 'border-bottom': hasDiscussions }"
            :discussion="discussion"
            :auto-focus="true"
            @closeDiscussion="closeDiscussion"
            @submitReply="onSubmitReply($event, discussion)"
            @hide="hideHandler"
          />
        </td>
      </tr>
    </Transition>
    <tr v-if="hasDiscussions && showEditor">
      <td
        colspan="4"
        class="p-0"
      >
        <div class="w-100 d-flex border-top border-bottom">
          <div class="m-3 d-flex flex-column w-100">
            <gf-custom-text-editor
              ref="diffLineMergeRequestEditor"
              class="mx-3"
              editor-variant="editor"
              :has-close-button="true"
              :submit-button-text="$t('message.create_discussion_new')"
              placeholder="Напишите комментарий для дискуссии здесь"
              :close-on-unfocus="true"
              @close="showEditor = false"
              @submit="submitDiscussion"
            />
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
// eslint-disable-next-line max-len
import MergeRequestDiscussionReply from '@shared/modules/merge-request/components/merge-request-discussion-reply';
// eslint-disable-next-line max-len
import MergeRequestDiscussionReplyForm from '@shared/modules/merge-request/components/merge-request-discussion-reply-form';
import { EventBus, EventEnums } from '@shared/event-bus';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import GfCustomTextEditor from '../shared/GfCustomTextEditor.vue';

export default {
  name: 'CommitDiffItemLine',
  components: {
    MergeRequestDiscussionReplyForm,
    MergeRequestDiscussionReply,
    GfCustomTextEditor
  },
  props: {
    line: Object,
    hasDiscussions: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isVisible: false,
      showEditor: false,
      form: {},
      areRepliesHidden: false
    };
  },
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    discussion() {
      const discussion = this.$store.getters.getDiscussionByLineId(this.line.id);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.areRepliesHidden = discussion?.note?.resolved;
      return discussion;
    },
    hideRepliesButtonText() {
      return this.areRepliesHidden
        ? `Показать ответы (${this.discussion?.replies?.length})`
        : `Скрыть ответы (${this.discussion?.replies?.length})`;
    },
    hideRepliesButtonIcon() {
      return this.areRepliesHidden ? ' gf-icon gf-icon-arrow-down' : ' gf-icon gf-icon-arrow-up';
    },
    isSeparator() {
      return this.line.type === 'separator';
    }
  },
  beforeDestroy() {
    EventBus.$off(EventEnums.MERGE_REQUEST_DISCUSSION_CREATED);
  },
  mounted() {
    // eslint-disable-next-line no-return-assign
    EventBus.$on(EventEnums.MERGE_REQUEST_DISCUSSION_CREATED, () => (this.showEditor = false));
    this.areRepliesHidden = this.discussion?.note?.resolved;
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    async submitDiscussion(data) {
      this.form.comment = await data;
      if (this.form.comment) this.$emit('submitDiscussion', this.form.comment);
      this.showEditor = false;
    },
    closeDiscussion() {
      this.$emit('closeDiscussion', this.discussion);
    },
    onSubmitReply(data, discussion) {
      this.$emit('submitReply', { discussion, data });
      this.showEditor = false;
    },
    onDiscussionDelete(data) {
      this.$store.dispatch('deleteMergeRequestDiscussionById', data?.id);
    },
    onDiscussionReplyDelete(data) {
      this.$store.dispatch('deleteMergeRequestDiscussionReplyById', data?.id);
    },
    hideHandler() {}
  }
};
</script>

<style scoped lang="scss">
.chunk-num.no-select {
  -webkit-user-select: none; /* Sai */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */

  &:before {
    content: attr(data-before);
    display: initial;
  }
}

.discussion-enter-active,
.discussion-leave-active {
  transition: all 0.1s ease;
}

.discussion-enter-from,
.discussion-leave-to {
  opacity: 0;
}
</style>
